import {css} from "@emotion/react"

const NewsLabel = ({label}: {label: string}) => {
  return <div css={styles}>{label}</div>
}

export default NewsLabel

const styles = css`
  width: fit-content;
  background-color: #eaeff0;
  font-size: 1.4rem;
  font-weight: 500;
  color: black;
  padding: 0.05rem 1rem;
  border-radius: 1.2rem;
`
